'use client';
/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{toastOptions as t}from"../../lib/toastOptions.js";import o from"react";import{Toaster as s}from"../../node_modules/react-hot-toast/dist/index.js";const a=({options:a})=>o.createElement(s,{position:"top-right",containerClassName:"toast-container",toastOptions:a||t});export{a as default};
//# sourceMappingURL=Toaster.js.map
